<template>
  <base-container class="data-picker-page">
    <cube-basic-picker />

    <view class="picker-divider-wrapper">
      <cube-divider />
    </view>

    <cube-time-picker />

    <view class="picker-divider-wrapper">
      <cube-divider />
    </view>

    <cube-date-time-picker />

    <view class="picker-divider-wrapper">
      <cube-divider />
    </view>

    <cube-order-picker />

    <view class="picker-divider-wrapper">
      <cube-divider />
    </view>


    <cube-formate-picker />
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({})
</script>

<style lang="stylus" scoped>
.picker-divider-wrapper
  margin 10px 0
</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "cube-divider": "@mpxjs/mpx-cube-ui/src/components/divider/index",
      "cube-basic-picker": "./basic-picker",
      "cube-order-picker": "./order-picker",
      "cube-time-picker": "./time-picker",
      "cube-date-time-picker": "./date-time-picker",
      "cube-formate-picker": "./formate-picker"
    }
  }
</script>
